import { Box, Button, Grid, IconButton, Text, Textarea, VStack } from "@chakra-ui/react";
import { Field } from "@chakra-ui/react/field";
import { MdAdd as AddIcon, MdClose as CloseIcon } from "react-icons/md";

interface Props {
  instructions: string[];
  error?: string;
  onChange: (index: number, value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  sectionHeadingStyle: object;
  dashedAddStyle: object;
  fieldRef: React.RefObject<HTMLDivElement | null>;
}

export default function MethodList({
  instructions, error, onChange, onAdd, onRemove,
  sectionHeadingStyle, dashedAddStyle, fieldRef,
}: Props) {
  return (
    <Box ref={fieldRef} w="100%">
      <Field.Root invalid={!!error} w="100%">
        <Box {...sectionHeadingStyle}>Method</Box>
        <VStack gap={3} align="stretch" w="100%">
          {instructions.map((instruction, index) => (
            <Grid key={index} templateColumns="32px 1fr 28px" gap="6px" alignItems="start" w="100%">
              <Text fontFamily="heading" fontWeight="800" fontSize="16px" color="accent.emphasis" lineHeight="1" mt="9px">
                {index + 1}
              </Text>
              <Textarea
                id={`instruction-${index}`}
                value={instruction}
                onChange={e => onChange(index, e.target.value)}
                placeholder={`Step ${index + 1}`}
                bg="bg.surface"
                border="1.5px solid"
                borderColor="border.default"
                borderRadius="8px"
                _hover={{ borderColor: "accent.secondary" }}
                _focus={{ borderColor: "accent.emphasis", boxShadow: "none" }}
                color="text.primary"
                fontSize="13px"
                lineHeight="1.5"
                minH={{ base: "80px", lg: "96px" }}
                resize="vertical"
              />
              <IconButton
                aria-label={`Remove step ${index + 1}`}
                size="xs"
                variant="ghost"
                color="text.muted"
                borderRadius="8px"
                _hover={{ bg: "bg.muted", color: "status.error" }}
                disabled={instructions.length === 1}
                onClick={() => onRemove(index)}
                mt="9px"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          ))}

          <Button {...dashedAddStyle} onClick={onAdd}>
            <AddIcon />
            Add step
          </Button>
        </VStack>
        {error && <Field.ErrorText mt={2}>{error}</Field.ErrorText>}
      </Field.Root>
    </Box>
  );
}
